module.exports = __webpack_public_path__ + "static/Delphi-b9b9e1f9db659d20a91712be27be0d10.svg";